var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MediaQueryProvider",
    { attrs: { queries: _vm.$options.queries, ssr: "" } },
    [
      _c(
        "div",
        {
          staticClass: "catalog-vue",
          attrs: {
            id: "catalog-vue",
            "data-redirect-to-page": _vm.redirectToPage
          }
        },
        [
          _c("LazyHydrate", { attrs: { never: "" } }, [
            _vm.isSearchPage
              ? _c("div", {
                  staticClass: "dfpAd search",
                  attrs: { id: "div-gpt-ad-1676540049228-0" }
                })
              : _c("div", {
                  staticClass: "dfpAd top-banner",
                  attrs: { id: "div-gpt-ad-LEADBOARD-0" }
                })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "catalog-ad" }, [
            _c("div", { staticClass: "breadcrumbs-desktop-container" })
          ]),
          _vm._v(" "),
          _c(
            "Layout",
            {
              attrs: { "is-loading": _vm.isLoading },
              scopedSlots: _vm._u(
                [
                  !_vm.category.isContentMode &&
                  _vm.category.layout !== "one_column"
                    ? {
                        key: "aside",
                        fn: function() {
                          return [
                            _c("LazyHydrate", { attrs: { "when-idle": "" } }, [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "aside-filters" },
                                  [
                                    !_vm.isSearchPage && _vm.categoryList
                                      ? _c("CategoryTree", {
                                          attrs: {
                                            "category-list": _vm.categoryList
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.filters
                                      ? _c("FilterList", {
                                          attrs: {
                                            filters: _vm.filters,
                                            "category-tree":
                                              _vm.category.categoryTree,
                                            "category-path": _vm.category.path
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { class: { noProducts: _vm.isCategoryEmpty } },
                [
                  _c("CategoryContent", {
                    attrs: {
                      category: _vm.category,
                      "is-search-page": _vm.isSearchPage,
                      params: _vm.params,
                      "query-string": _vm.queryString
                    }
                  }),
                  _vm._v(" "),
                  !_vm.category.isContentMode
                    ? [
                        _c("MatchMedia", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var mobile = ref.mobile
                                  return [
                                    mobile
                                      ? [
                                          _c(
                                            "LazyHydrate",
                                            { attrs: { "when-visible": "" } },
                                            [
                                              _c("FilterListMobile", {
                                                attrs: {
                                                  "trigger-mobile-filter":
                                                    _vm.triggerMobileFilter,
                                                  "trigger-data-filter-name":
                                                    _vm.triggerDataFilterName
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "before-filters",
                                                      fn: function() {
                                                        return [
                                                          !_vm.isSearchPage &&
                                                          _vm.categoryList
                                                            ? _c(
                                                                "CategoryTree",
                                                                {
                                                                  attrs: {
                                                                    "category-list":
                                                                      _vm.categoryList
                                                                  }
                                                                }
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3780697278
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "LazyHydrate",
                          { attrs: { "when-idle": "" } },
                          [
                            _c("Pager", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "left",
                                    fn: function() {
                                      return [
                                        Object.keys(_vm.filtersActive).length
                                          ? _c("FilterListActive", {
                                              attrs: {
                                                "filters-active":
                                                  _vm.getFiltersActive,
                                                "is-mobile": _vm.isMobile
                                              },
                                              on: {
                                                chooseMobileFilter:
                                                  _vm.chooseMobileFilter
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "right",
                                    fn: function() {
                                      return [
                                        _c("CatalogSort", {
                                          staticClass: "hidden-mobile"
                                        }),
                                        _vm._v(" "),
                                        _c("Limiter"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "view-toggle" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active:
                                                    _vm.viewMode === "grid"
                                                },
                                                attrs: {
                                                  "aria-label":
                                                    "Kafelkowy układ produktów"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setViewMode(
                                                      "grid"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("GridListIcon", {
                                                  attrs: {
                                                    width: "30",
                                                    height: "30",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active:
                                                    _vm.viewMode === "list"
                                                },
                                                attrs: {
                                                  "aria-label":
                                                    "Kolumnowy układ produktów"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setViewMode(
                                                      "list"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("RowListIcon", {
                                                  attrs: {
                                                    width: "30",
                                                    height: "30",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1534744434
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("LazyHydrate", { attrs: { "when-idle": "" } }, [
                          _c(
                            "div",
                            { staticClass: "filters-quick-container" },
                            [
                              _vm.filters.quick_filters &&
                              !Object.keys(_vm.filtersActive).length
                                ? _c("FilterListQuick", {
                                    attrs: {
                                      "filters-quick": _vm.filters.quick_filters
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "LazyHydrate",
                          { attrs: { "when-idle": "" } },
                          [
                            _c(
                              "ProductList",
                              {
                                attrs: {
                                  products: _vm.products,
                                  "is-search-page": _vm.isSearchPage,
                                  "view-mode": _vm.viewMode
                                }
                              },
                              [
                                _c(
                                  "LazyHydrate",
                                  { attrs: { never: "" } },
                                  [
                                    !_vm.isLoading
                                      ? [
                                          _c("p", { staticClass: "note-msg" }, [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.i18n("No Items Found")
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        ]
                                      : _vm.isSearchPage
                                      ? [
                                          _c("p", { staticClass: "note-msg" }, [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.i18n(
                                                    "Searching in progress"
                                                  )
                                                ) +
                                                "\n                                        " +
                                                _vm._s(_vm.i18n("for")) +
                                                ":\n                                        " +
                                                _vm._s(_vm.params.q) +
                                                "\n                                    "
                                            )
                                          ])
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("LazyHydrate", { attrs: { "when-idle": "" } }, [
                          _vm.products && _vm.products.length
                            ? _c(
                                "div",
                                { staticClass: "pagination-section" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pagination-state-container"
                                    },
                                    [_c("PaginationState")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("PaginationList")
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.category.cloudTags &&
                        _vm.category.cloudTags.length > 0
                          ? _c(
                              "div",
                              { staticClass: "catalogTagCloud" },
                              _vm._l(_vm.category.cloudTags, function(
                                cloudTag
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: cloudTag.key,
                                    staticClass: "cloud-tag button"
                                  },
                                  [
                                    _c("a", { attrs: { href: cloudTag.url } }, [
                                      _vm._v(_vm._s(cloudTag.name))
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }